<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <groups-list
                :teamId="props.teamId"
                :overview="false"
                :newGroupHref="`/kiosk/groups/new?team_id=${props.teamId}`"
                :editGroupHref="editGroupHref"
                :isKiosk="true"
            />
        </div>
    </kiosk-team-details>
</template>

<script lang="ts" setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import GroupsList from '~/components/settings/teams/groups/list/GroupsList.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const editGroupHref = (group: { team_id: number; group_id: string; name?: string }) => {
    if (!group.name?.length) {
        return `/kiosk/groups/new?team_id=${group.team_id}&setup_group_id=${group.group_id}`;
    }

    return `/kiosk/teams/${group.team_id}/groups/${group.group_id}`;
};
</script>
